import { motion } from 'motion/react'
import { ArrowUpRight, FileUp, FolderOpen } from 'lucide-react'
import { t } from '../i18n'
import type { ProjectMeta } from '../types'

interface Props {
  onChoose: () => void
  onChooseFolder: () => void
  onDemo: () => void
  projects: ProjectMeta[]
  onOpen: (id: string) => void
}

export function EmptyState({ onChoose, onChooseFolder, onDemo, projects, onOpen }: Props) {
  return (
    <section className="empty-stage">
      <div className="empty-inner">
        <motion.div
          className="drop-target"
          initial={{ opacity: 0, y: 10, scale: 0.99 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ type: 'spring', stiffness: 260, damping: 28 }}
        >
          <span className="drop-mark">
            <BoardOutline />
          </span>
          <h1>{t('empty.title')}</h1>
          <p>{t('empty.body')}</p>
          <div className="drop-actions">
            <button className="btn btn-primary" type="button" onClick={onChoose}>
              <FileUp size={15} />
              {t('empty.choose')}
            </button>
            <button className="btn" type="button" onClick={onChooseFolder}>
              <FolderOpen size={15} />
              {t('empty.chooseFolder')}
            </button>
            <button className="btn" type="button" onClick={onDemo}>
              {t('empty.demo')}
              <ArrowUpRight size={14} />
            </button>
          </div>
          <span className="drop-limit">{t('empty.limit')}</span>
        </motion.div>

        {projects.length > 0 ? (
          <div className="recent">
            <span className="recent-label">{t('empty.recent')}</span>
            <div className="recent-grid">
              {projects.slice(0, 4).map((project) => (
                <button className="recent-card" type="button" key={project.id} onClick={() => onOpen(project.id)}>
                  <span className="recent-thumb">
                    {project.thumbnail ? <img src={project.thumbnail} alt="" loading="lazy" /> : null}
                  </span>
                  <strong>{project.name}</strong>
                  <small>{project.stats.widthMm.toFixed(1)} × {project.stats.heightMm.toFixed(1)} mm</small>
                </button>
              ))}
            </div>
          </div>
        ) : null}
      </div>
    </section>
  )
}

function BoardOutline() {
  return (
    <svg viewBox="0 0 150 104" fill="none" stroke="currentColor" strokeWidth="1">
      <rect x="8.5" y="8.5" width="133" height="87" rx="5" />
      <rect x="24.5" y="24.5" width="101" height="55" rx="3" strokeDasharray="3 4" />
      <path d="M38 39h18v-8M38 65h18v8M112 39H94v-8M112 65H94v8" />
      <rect x="64.5" y="41.5" width="21" height="21" rx="2" />
      <circle cx="75" cy="52" r="4.5" />
      <path d="M51 52h9M90 52h9M75 33v6M75 65v6" strokeDasharray="2 3" />
      <circle cx="30" cy="52" r="2" />
      <circle cx="120" cy="52" r="2" />
      <path d="M18 18h6M18 18v6M132 86h-6M132 86v-6" />
    </svg>
  )
}
